// src/pages/B2B/crm/components/VenueContactRow.tsx
import React, { useState } from 'react';
import { VenueContact } from '../api/types';

interface Props {
  contact: VenueContact;
  onSave: (patch: Partial<VenueContact>) => Promise<void>;
  onDelete: () => Promise<void>;
}

export function VenueContactRow({ contact, onSave, onDelete }: Props) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(contact);
  const [busy, setBusy] = useState(false);

  if (!editing) {
    return (
      <div className="flex items-start justify-between py-2 border-b border-[#1f1f33] last:border-b-0">
        <div>
          <div className="text-gray-200 text-sm">{contact.name}</div>
          <div className="text-gray-500 text-xs">
            {[contact.title, contact.phone, contact.email].filter(Boolean).join(' · ') || '—'}
          </div>
        </div>
        <div className="flex gap-2 text-xs">
          <button onClick={() => setEditing(true)} className="text-violet-400 hover:text-violet-300">Edit</button>
          <button
            onClick={async () => { setBusy(true); try { await onDelete(); } finally { setBusy(false); } }}
            disabled={busy}
            className="text-red-400 hover:text-red-300 disabled:opacity-50"
          >
            Remove
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="py-2 border-b border-[#1f1f33] last:border-b-0 space-y-1">
      <input className="w-full bg-[#0f0f1a] border border-[#2a2a3e] rounded px-2 py-1 text-sm text-gray-200" placeholder="Name"
             value={draft.name} onChange={e => setDraft({ ...draft, name: e.target.value })} />
      <input className="w-full bg-[#0f0f1a] border border-[#2a2a3e] rounded px-2 py-1 text-sm text-gray-200" placeholder="Title"
             value={draft.title ?? ''} onChange={e => setDraft({ ...draft, title: e.target.value })} />
      <div className="flex gap-1">
        <input className="flex-1 bg-[#0f0f1a] border border-[#2a2a3e] rounded px-2 py-1 text-sm text-gray-200" placeholder="Phone"
               value={draft.phone ?? ''} onChange={e => setDraft({ ...draft, phone: e.target.value })} />
        <input className="flex-1 bg-[#0f0f1a] border border-[#2a2a3e] rounded px-2 py-1 text-sm text-gray-200" placeholder="Email"
               value={draft.email ?? ''} onChange={e => setDraft({ ...draft, email: e.target.value })} />
      </div>
      <div className="flex justify-end gap-2 text-xs">
        <button onClick={() => { setDraft(contact); setEditing(false); }} className="text-gray-400">Cancel</button>
        <button
          onClick={async () => {
            setBusy(true);
            try { await onSave(draft); setEditing(false); } finally { setBusy(false); }
          }}
          disabled={busy}
          className="text-violet-400 hover:text-violet-300 disabled:opacity-50"
        >
          Save
        </button>
      </div>
    </div>
  );
}
